<template>
    <b-row>
        <b-col md="12">
            <ul class="heading-ul">
                <li>
                    <router-link to="/setup/Resources" class="mr-2">
                        <i
                            class="fa fa-arrow-left back-icon"
                            aria-hidden="true"
                        ></i>
                    </router-link>
                </li>
                <li><h3>Edit Currency</h3></li>
            </ul>
        </b-col>
        <b-col md="12" class="pb-0 pt-0">
            <div v-if="loading" class="text-center py-4">
                <span><b>Loading currency...</b></span>
            </div>
            <b-card v-else-if="resource" class="custome-card mb-3">
                <b-row v-if="renderIsCurrencyData">
                    <b-col md="6">
                        <!-- <b-form-input
              inputType="text"
              placeholder="Currency"
              class="mt-0"
              v-model="currency"
            /> -->
                        <div class="form-group">
                            <eb-select
                                type="select"
                                :options="resourceData"
                                label="resourceCode"
                                id="ResourceCode"
                                placeholder="Currency"
                                class="mt-0"
                                v-model="currency"
                                :selected="currency"
                                @input="onSelectCode(currency)"
                            ></eb-select>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Currency Name"
                                class="mt-0"
                                v-model="currencyName"
                            />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Currency Symbol"
                                class="mt-0"
                                readonly
                                v-model="selectedSymbol"
                            />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Resource ID"
                                class="mt-0"
                                v-model="resourceID"
                            />
                        </div>
                    </b-col>
                </b-row>

                <b-row v-if="!renderIsCurrencyData">
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Currency"
                                class="mt-0"
                                v-model="currency"
                            />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Currency Name"
                                class="mt-0"
                                v-model="currencyName"
                            />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Currency Symbol"
                                class="mt-0"
                                readonly
                                v-model="selectedSymbol"
                            />
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="form-group">
                            <b-form-input
                                inputType="text"
                                placeholder="Resource ID"
                                class="mt-0"
                                v-model="resourceID"
                            />
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <b-card v-else class="custome-card mb-3">
                <div class="text-center py-4 text-muted">
                    Currency not found or failed to load.
                </div>
            </b-card>
        </b-col>

        <b-col md="12" v-if="resource && renderIsCurrencyData">
            <h3>Add Currency Exchange Rate</h3>
        </b-col>
        <b-col md="12" class="pb-0 pt-0" v-if="resource && renderIsCurrencyData">
            <b-card class="custome-card mb-3">
                <ValidationObserver ref="observer" v-slot="{ invalid }">
                    <b-row>
                        <b-col class="mt-3" md="3">
                            <span class="ml-1">Select Currency</span>
                            <eb-select
                                placeholder="Select Currency"
                                label="text"
                                type="select"
                                v-model="selectCurrency"
                                @input="selectCurrencyData(selectCurrency)"
                                clearable
                                :options="resourceCurrency"
                            />
                        </b-col>
                        <b-col class="mt-3" md="3">
                            <span class="ml-1">Enter Exchange Rate</span>
                            <b-form-input
                                type="number"
                                placeholder="Enter Exchange Rate"
                                class="mt-0"
                                v-model="exchangeRate"
                            />
                        </b-col>
                        <b-col class="mt-3" md="3">
                            <ValidationProvider
                                rules="futureDisable"
                                v-slot="{ errors }"
                                name="start-date"
                            >
                                <span class="ml-1">Start Date</span>
                                <b-form-input
                                    type="date"
                                    v-model="effetiveStartDate"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                        <b-col class="mt-3" md="3">
                            <ValidationProvider
                                rules="futureDisable|afterDate:start-date"
                                v-slot="{ errors }"
                                name="end-date"
                            >
                                <span class="ml-1">End Date</span>
                                <b-form-input
                                    type="date"
                                    v-model="effetiveEndDate"
                                />
                                <span class="validate-error">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="12" class="text-right mt-3">
                            <button
                                type="button"
                                class="btn btn-primary w-30"
                                :disabled="invalid"
                                @click="addCurrencyData"
                            >
                                Add
                            </button>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </b-card>
        </b-col>
        <b-col md="12" v-if="resource && renderIsCurrencyData">
            <b-card class="custome-card">
                <div>
                    <b-table
                        class="professional-stacked-table"
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        stacked="md"
                        :items="showExchangeRate"
                        :fields="currencyAddPage"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        @filtered="onFilter"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(updatedAt)" slot-scope="data">
                            <div>{{ data.item.updatedAt | formatedate }}</div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                        <template slot-scope="data" slot="cell(action)">
                            <div class="inline_btnTable">
                                <b-button
                                    size="sm"
                                    class="mr-2 button-circle"
                                    @click="onClickDelete(data.index)"
                                    variant="danger"
                                >
                                    <i class="fas fa-trash-alt"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="float-right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>

        <!-- <b-col md="12">
            <div class="text-center mb-5 mt-2 p-4">
                <button
                    variant="danger"
                    type="button"
                    class="text-uppercase btn btn-lg btn-danger mr-3 w-15"
                    @click="backToResources"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="text-uppercase btn btn-lg btn-primary ml-3 w-15"
                    classic="mr-1 btn-primary"
                    text="Save"
                    @click="addCurrencyEvent"
                >
                    Update
                </button>
            </div>
        </b-col> -->
         <div class="buttons d-flex justify-content-center mb-3 mt-0">
           <b-button variant="danger" class="action-btn"  @click="backToResources">
           CANCEL
           </b-button>
           <b-button variant="primary" class="action-btn ml-2"   @click="addCurrencyEvent">
            UPDATE
           </b-button>
       </div>
    </b-row>
</template>
<script>
import { mapState } from "vuex";
import Vue from "vue";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import { resourcesCurrency } from "@/utils/resourcesCurrency";
import currency from "@/store/currency";
import moment from "moment";
import {
    ValidationObserver,
    ValidationProvider,
    Validator,
} from "vee-validate";
export default {
    name: "editCurrency",
    data() {
        return {
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            sortBy: "updatedAt",
            sortDesc: true,
            showExchangeRate: [],
            currencyAddPage: [
                {
                    key: "code",
                    label: "Currency",
                },
                {
                    key: "rate",
                    label: "Exchange Rate",
                },
                {
                    key: "startDate",
                    label: "Effective Start Date",
                    formatter: (value) => moment(value).format("DD-MM-YYYY"),
                },
                {
                    key: "endDate",
                    label: "Effective End Date",
                    formatter: (value) => moment(value).format("DD-MM-YYYY"),
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: { width: "8%" },
                },
            ],
            currency: "",
            currencyName: "",
            selectCurrency: "",
            selectedSymbol: "",
            exchangeRate: null,
            effetiveStartDate: "",
            effetiveEndDate: "",
            resourceID: "",
            rate: "",
            startDate: "",
            endDate: "",
            isCurrency: false,
            selectedCurrency: {},
        };
    },
    components: {
        ebSelect,
        ValidationObserver,
        ValidationProvider,
    },
    computed: {
        ...mapState({
            fetchCurrencyList: (state) => state.currency.fetchCurrencyList,
            fetchCurrencyView: (state) => state.currency.fetchCurrencyView,
        }),
        resource() {
            return (this.fetchCurrencyView && this.fetchCurrencyView.response) || null;
        },
        resourceData() {
            return resourcesCurrency;
        },
        renderIsCurrencyData() {
            if (this.resource) return this.resource.isCurrency === true;
            const data = this.fetchCurrencyList.find(
                (currencyData) => currencyData._id === this.$route.params.id,
            );
            return data ? data.isCurrency === true : false;
        },
        resourceCurrency() {
            let currencyVar = [];
            this.fetchCurrencyList.forEach((currencyDetails) => {
                if (currencyDetails.isCurrency === true) {
                    currencyVar.push({
                        text: currencyDetails.code,
                        value: currencyDetails._id,
                    });
                }
            });
            const unique = [
                ...new Map(
                    currencyVar.map((item) => [item.text, item]),
                ).values(),
            ];
            return unique;
        },
    },
    methods: {
        populateFormFromResource() {
            const res = this.resource;
            if (!res) return;
            
            this.currencyName = res.name || "";
            this.selectedSymbol = res.symbol || "";
            this.resourceID = res.resourceID || res._id || "";
            this.isCurrency = res.isCurrency === true;
            
            // For currency select dropdown, find matching object from resourceData
            if (this.isCurrency && res.code) {
                const matchingCurrency = this.resourceData.find(
                    (item) => item.resourceCode === res.code
                );
                if (matchingCurrency) {
                    this.currency = matchingCurrency;
                } else {
                    this.currency = res.code;
                }
            } else {
                this.currency = res.code || "";
            }
            
            // Populate exchange rates
            const rates = res.exchangeRates || [];
            this.showExchangeRate = rates.map((e) => ({
                id: e._id,
                code: (e.resource && e.resource.code) || e.code || "",
                rate: e.rate,
                startDate: e.startDate ? String(e.startDate).slice(0, 10) : "",
                endDate: e.endDate ? String(e.endDate).slice(0, 10) : "",
            }));
        },
        onSelectCode(e) {
            this.currency = e.resourceCode;
            this.currencyName = e.resourceName;
            this.resourceID = e.resourceId;
            this.selectedSymbol = e.resourceSymbol;
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        async addCurrencyEvent() {
            if (this.isCurrency) {
                // Handle currency as object (from select) or string
                const currencyCode = typeof this.currency === 'object' 
                    ? this.currency.resourceCode 
                    : this.currency;
                
                let payload = {
                    resourceID: this.resourceID,
                    code: currencyCode,
                    name: this.currencyName,
                    symbol: this.selectedSymbol,
                    isCurrency: this.isCurrency,
                    exchangeRates: [],
                    _id: this.$route.params.id,
                };
                payload.exchangeRates = this.showExchangeRate.map((el) => {
                    return {
                        resource: {
                            code: el.code,
                        },
                        startDate: el.startDate,
                        endDate: el.endDate,
                        rate: el.rate,
                    };
                });
                await this.$store
                    .dispatch("currency/currencyEditAction", payload)
                    .then(async (res) => {
                        this.currency = "";
                        this.currencyName = "";
                        this.selectCurrency = "";
                        this.exchangeRate = null;
                        this.effetiveStartDate = "";
                        this.effetiveEndDate = "";
                        this.$router.push("/setup/Resources");
                    });
            } else {
                // Handle currency as string
                const currencyCode = typeof this.currency === 'object' 
                    ? this.currency.resourceCode 
                    : this.currency;
                
                let payload = {
                    resourceID: this.resourceID,
                    code: currencyCode,
                    name: this.currencyName,
                    isCurrency: this.isCurrency,
                    _id: this.$route.params.id,
                };
                await this.$store
                    .dispatch("currency/currencyEditAction", payload)
                    .then(async (res) => {
                        this.currency = "";
                        this.currencyName = "";
                        this.selectCurrency = "";
                        // this.exchangeRate = null;
                        // this.effetiveStartDate = "";
                        // this.effetiveEndDate = "";
                        this.$router.push("/setup/Resources");
                    });
            }
        },
        addCurrencyData() {
            if (
                !this.selectCurrency ||
                !this.exchangeRate ||
                !this.effetiveStartDate ||
                !this.effetiveEndDate
            ) {
                this.$toasted.error("Please fill all fields");
                return;
            }
            const dateValid =
                this.effetiveStartDate &&
                this.effetiveEndDate &&
                moment(this.effetiveStartDate).diff(
                    this.effetiveEndDate,
                    "day",
                ) < 0;
            if (!dateValid) {
                this.$toasted.error("Please select valid date range");
                return;
            }
            if (this.showExchangeRate.length > 0) {
                const addedStartDate =
                    this.showExchangeRate[this.showExchangeRate.length - 1]
                        .startDate === this.effetiveStartDate;
                const addedEndDate =
                    this.showExchangeRate[this.showExchangeRate.length - 1]
                        .endDate === this.effetiveEndDate;
                if (addedStartDate && addedEndDate) {
                    this.showCustomToast1();
                } else {
                    let currencyExchangeData = {
                        code: this.selectCurrency,
                        rate: this.exchangeRate,
                        startDate: this.effetiveStartDate,
                        endDate: this.effetiveEndDate,
                    };
                    this.showExchangeRate.push(currencyExchangeData);
                    this.selectCurrency = "";
                    this.exchangeRate = "";
                    this.effetiveStartDate = "";
                    this.effetiveEndDate = "";
                    this.selectCurrencyData("");
                }
            } else {
                if (this.effetiveStartDate == "") {
                    this.showCustomToast2();
                }
                let currencyExchangeData = {
                    code: this.selectCurrency,
                    rate: this.exchangeRate,
                    startDate: this.effetiveStartDate,
                    endDate: this.effetiveEndDate,
                };
                this.showExchangeRate.push(currencyExchangeData);
            }
        },
        showCustomToast1() {
            Vue.toasted.show("Please Add Time period.", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 10000,
            });
        },
        showCustomToast2() {
            Vue.toasted.show(
                "The exchange rate had already been added during that period.",
                {
                    type: "info",
                    theme: "toasted-primary",
                    singleton: true,
                    duration: 10000,
                },
            );
        },
        onClickDelete(index) {
            this.showExchangeRate.splice(index, 1);
        },
        selectCurrencyData(e) {
            this.selectCurrency = e.text;
        },
        backToResources() {
            this.$router.push("/setup/Resources");
        },
    },

    async mounted() {
        this.loading = true;
        try {
            await this.$store.dispatch("currency/fetchCurrencySetupList", "y");
            await this.$store.dispatch(
                "currency/fetchCurrencyDetail",
                this.$route.params.id,
            );
            this.populateFormFromResource();
        } catch (error) {
            this.$toasted.error("Unable to load currency for editing");
        } finally {
            this.loading = false;
        }
        // this.exchangeRate = editData?.exchangeRates[0]?.rate;
        // this.effetiveStartDate = editData?.exchangeRates[0]?.startDate;
        // this.effetiveEndDate = editData?.exchangeRates[0]?.endDate;

        Validator.extend(
            "afterDate",
            (value, [otherValue]) => {
                return moment(value).diff(this.effetiveStartDate, "hour") >= 0;
            },
            {
                hasTarget: true,
            },
        );
        Validator.extend(
            "futureDisable",
            (value, [otherValue]) => {
                return moment().diff(this.effetiveStartDate, "hour") >= 0;
            },
            {
                hasTarget: true,
            },
        );
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
};
</script>
<style scoped>
.heading-ul {
    padding: 0;
}

.heading-ul li {
    list-style: outside none;
    display: inline-block;
    margin-right: 10px;
}

.back-icon {
    font-size: 18px;
    color: #262626;
}

.buttons {
    width: 100%;
    max-width: 300px;
    margin: 30px auto 0;
}

.buttons .action-btn {
    width: 120px;
    height: 35px;
}

@media (min-width: 576px) {
    .buttons {
        width: 20%;
    }
}
</style>
